import { FC } from "react";
import { Card } from "../styles/CardStyles";
import { Modal, Stack, Typography } from "@mui/material";
import styled from "styled-components";
import { Oval } from "react-loader-spinner";
import Tick from "./Tick";
import Error from "./Error";

export type TxnPendingState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  /** Revert reason or best-effort message from the contract / RPC */
  errorMessage?: string;
  /** What the user can try next */
  errorHint?: string;
};

interface ITxnStateModal {
  open: boolean;
  handleClose: () => void;
  txnPending: TxnPendingState;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "min(500px, 92vw)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  minHeight: "250px",
  maxHeight: "85vh",
  overflow: "auto",
};

export const OvalContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TxnStateModal: FC<ITxnStateModal> = ({
  open,
  handleClose,
  txnPending,
}) => {
  const sizeOfTxnStates = 75;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Card
          sx={style}
          style={{ justifyContent: "space-between" }}
        >
          {txnPending.loading && (
            <OvalContainer>
              <Oval
                height={sizeOfTxnStates}
                width={sizeOfTxnStates}
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#4fa94d"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            </OvalContainer>
          )}
          {txnPending.success && <Tick size={sizeOfTxnStates} />}
          {txnPending.failure && (
            <Stack spacing={2} alignItems="center" width="100%">
              <OvalContainer style={{ minHeight: 90 }}>
                <Error width={sizeOfTxnStates} />
              </OvalContainer>
              <Typography variant="subtitle2" component="p" textAlign="center" color="error">
                Transaction failed
              </Typography>
              {txnPending.errorMessage ? (
                <Stack spacing={1} width="100%">
                  <Typography variant="body2" component="p" textAlign="center" fontWeight={600}>
                    {txnPending.errorMessage}
                  </Typography>
                  {txnPending.errorHint ? (
                    <Typography
                      variant="caption"
                      component="p"
                      textAlign="center"
                      color="text.secondary"
                      sx={{ lineHeight: 1.5 }}
                    >
                      {txnPending.errorHint}
                    </Typography>
                  ) : null}
                </Stack>
              ) : null}
            </Stack>
          )}
        </Card>
      </>
    </Modal>
  );
};

export default TxnStateModal;
